import styled, { css } from 'styled-components';
import breakpoints from 'theme/atoms/breakpoints';
import colours from 'theme/atoms/colours';

const mobileButtonContainerStyles = css`
  position: fixed;
  bottom: 34px;
  left: 50%;
  transform: translateX(-50%);
  /* Below the side panel overlay (z-index: 100) */
  z-index: 90;
  pointer-events: none;

  > * {
    pointer-events: auto;
  }
`;

export const ButtonContainer = styled('div')<{ $mobileView?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  pointer-events: auto;

  ${({ $mobileView }) => $mobileView && mobileButtonContainerStyles}

  @media (max-width: ${breakpoints.tablet}) {
    ${mobileButtonContainerStyles}
  }
`;

export const RoundMicButton = styled('button')`
  appearance: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 100px;
  padding: 38px;
  box-sizing: border-box;
  border-radius: 300px;
  background-color: ${colours.primary[500]};
  color: ${colours.shade[0]};
  transition: background-color 0.15s ease, transform 0.1s ease;

  svg {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }

  svg path {
    stroke: ${colours.shade[0]};
    stroke-width: 2;
  }

  &:hover:not(:disabled),
  &:focus-visible:not(:disabled) {
    background-color: ${colours.primary[600]};
    outline: none;
  }

  &:active:not(:disabled) {
    transform: scale(0.96);
  }

  &:disabled {
    background-color: ${colours.primary[200]};
    cursor: not-allowed;
  }
`;
